/*
 * @Author: zhangzc
 * @Email: zhicheng.zhang@medbanks.cn
 * @Date: 2020-03-13 13:26:10
 * @Last Modified by: zhifen.zhu
 * @Last Modified time: 2022-02-14 15:05:52
 * @Description: 生产环境配置
 * @Route: Route
 */

export default {
  env: 'prod',
  baseUrl: '//api-gateway.medbanks.cn',
  // baseUrl: '//api-gateway.medbanks-test.com',
  baseRouter: '/checkToken/',
  wsUrl: 'wss://api-gateway.medbanks.cn/ws/connect',
  formChannels: '4afb239ac7183b90',
  // 微应用配置
  MICRO_APPS: {
    FOLLOW_VISIT: {
      name: 'follow-visit',
      entry: 'https://him.spcare.cn/',
      container: '#FOLLOW_VISIT',
    },
  },
  outer: 'https://him.spcare.cn',
  secret: 'L12c9QXylRHqVxtZ', // 登录密码加密密钥
  signatureResultPage: 'https://ihd.spcare.cn/signatureResult', // E签宝人脸识别跳转页
};
